/* Copyright (c) 2017 Backpack Health LLC */

/* global window, IS_ANDROID_BUILD */

import React from 'react';

import PrivacyIntro from './PrivacyIntro';

import AppUtils from '../../../../utilities/AppUtils';
import RouteNames from '../../../appAuthorized/RouteNames';
import { navigate, navigateBack } from '../../../appAuthorized/redux/NavigationActions';

const PrivacyIntroForNewSignup = () => (
  <PrivacyIntro
    isNewUser={true}
    onAccept={() => {
      navigate(RouteNames.signup());
    }}
    onCancel={() => {
      AppUtils.clearSavedIntent();
      if (IS_ANDROID_BUILD) {
        navigateBack(RouteNames.introEnd());
      } else {
        window.location.href = 'https://backpackhealth.com';
      }
    }}
    showLanguageControl={!IS_ANDROID_BUILD}
  />
);

export default PrivacyIntroForNewSignup;
